import {
  Box, Typography,
  useTheme,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import OptimusButton from '../../../common/library/Button/Button';
import { TestIds } from '../../../assets/testIds';
import { useOptimizelyFlag } from '../../../common/hooks/useOptimizelyFlag';
import { EdgeHomeNewDesignFlag } from '../../../common/OptimizelyFlagsConstants';
import { HOME_ROUTE, RESOURCES_ROUTE } from '../../../routes/namedRoutes';

export default function SavedContentEmptyStateView() {
  const { t } = useTranslation();
  const theme = useTheme();
  const navigate = useNavigate();

  const {
    decision: edgeHomeNewDesignDecision,
    isDecisionReady: isEdgeHomeNewDesignDecisionReady,
  } = useOptimizelyFlag({
    flag: EdgeHomeNewDesignFlag,
  });
  const isEdgeHomeNewDesignEnabled = isEdgeHomeNewDesignDecisionReady &&
    !!edgeHomeNewDesignDecision?.enabled;
  // In the top navigation Saved lives under Resources, so the CTA returns there
  const ctaRoute = isEdgeHomeNewDesignEnabled ? RESOURCES_ROUTE : HOME_ROUTE;
  const ctaText = isEdgeHomeNewDesignEnabled ? t('button.goToResources') : t('button.goToHomeFeed');

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        [theme.breakpoints.up('md')]: {
          width: '60%',
        },
        justifyContent: 'center',
        alignSelf: 'center',
        textAlign: 'center',
        backgroundColor: theme.palette.common.white,
        padding: theme.spacing(2.5),
        borderRadius: theme.spacing(1),
        border: `${theme.spacing(0.125)} solid ${theme.palette.grey[200]}`,
      }}
    >
      <Typography variant="h9" gutterBottom>
        {t('content.saved.emptyState.heading')}
      </Typography>
      <Typography variant="body2"
        sx={{
          marginTop: theme.spacing(2),
        }}
      >
        {t('content.saved.emptyState.description')}
      </Typography>
      <OptimusButton
        data-testid={TestIds.contentFeed.savedEmptyStateCtaBtn}
        size={'m'}
        width={'50%'}
        sx={{
          mb: theme.spacing(2),
          mt: theme.spacing(3),
          alignSelf: 'center',
        }}
        buttonText={ctaText || ''}
        onClick={() => navigate(ctaRoute)}
      />
    </Box>
  );
}
